import request from '@/utils/request'

// 查询列表
export function apiTeamList(query) {
  return request({
    url: '/bom/team/list',
    method: 'get',
    params: query
  })
}

// 修改
export function apiTeamUpdate (data) {
  return request({
    url: '/bom/team/save',
    method: 'post',
    data: data
  })
}

// 导出列表
export function apiTeamExport (data) {
  return request({
    url: '/bom/team/export',
    method: 'post',
    data: data
  })
}

// 删除
export function apiTeamDel (ids) {
  return request({
    url: '/bom/team/remove',
    method: 'post',
    data: ids
  })
}

// 查询列表
export function apiTeamEmployeeList(query) {
  return request({
    url: '/bom/team/employee/list',
    method: 'get',
    params: query
  })
}

// 修改
export function apiTeamEmployeeUpdate (data) {
  return request({
    url: '/bom/team/employee/save',
    method: 'post',
    data: data
  })
}

// 导出列表
export function apiTeamEmployeeExport (data) {
  return request({
    url: '/bom/team/employee/export',
    method: 'post',
    data: data
  })
}

// 删除
export function apiTeamEmployeeDel (ids) {
  return request({
    url: '/bom/team/employee/remove',
    method: 'post',
    data: ids
  })
}

/**
 * 获取日志代码
 * @description id 是业务编码， type是类型  ，不同的日志不同
班组日志：   id 是 班组编码 type 是 2
班组人员日志：   id 是 行ID type 是 3
班组排班日志：   id 是 行ID type 是 4
 * @param {Object} params
 * @returns
 */
export function apiGetLog(params) {
  return request({
    url: '/mes/mesWipLog/selectMesWipCommonLogs',
    method: 'get',
    params: params
  })
}
